var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1910",
    "data-name": "Group 1910",
    transform: "translate(-196 -679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fire",
    transform: "translate(192.423 676.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_3985",
    "data-name": "Path 3985",
    d: "M28.187,19.213c-.277-.659-.593-1.406-.9-2.328-.8-2.414,1.767-5.046,1.791-5.071l-1.441-1.441c-.143.143-3.488,3.544-2.284,7.155.332,1,.664,1.783.956,2.476a9.558,9.558,0,0,1,1.03,4.334,6.358,6.358,0,0,1-4.269,5.393,8.681,8.681,0,0,0-2.143-8.151l-1.064-1.064L19.271,21.9c-1.871,4.365-4.1,6.27-5.406,7.065a5.954,5.954,0,0,1-2.827-4.626,9.805,9.805,0,0,1,.947-3.7,11.547,11.547,0,0,0,1.091-4.453V14.377c.89.367,2.038,1.328,2.038,3.849v2.652l1.776-1.97c3.171-3.519,2.509-7.71,1.229-10.5a4.571,4.571,0,0,1,3.109,4.726h2.038C23.264,7.491,18.6,6,16.132,6H14.094l1.223,1.629c.14.188,2.916,4,1.378,7.833a5.036,5.036,0,0,0-4.639-3.349H11.038v4.075a9.805,9.805,0,0,1-.947,3.7A11.547,11.547,0,0,0,9,24.339c0,3.921,3.9,8.151,10.188,8.151s10.188-4.23,10.188-8.151a11.591,11.591,0,0,0-1.19-5.126ZM15.964,29.969a16.81,16.81,0,0,0,4.449-5.7,6.22,6.22,0,0,1,.262,6.084,11.534,11.534,0,0,1-1.486.1,10.523,10.523,0,0,1-3.225-.483Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 32,
    height: 32,
    transform: "translate(196 679)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.39eb7dbf410fa6adf910dac03b0d36f6.svg";
export { ForwardRef as ReactComponent };